import { AcmidmAuthService } from '@anb/ng-auth';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class AppHeaderComponent {
  @Input() title: string;
  @Input() logoutUrl: string;

  @Input() primaryMenuTemplate: TemplateRef<HTMLElement>;
  @Input() secondaryMenuTemplate: TemplateRef<HTMLElement>;

  constructor(readonly anbAuthService: AcmidmAuthService) {}

  logout(): boolean {
    window.location.href = this.logoutUrl;
    return false;
  }
}
